import { formatDateForUI, getServiceTypeString, getStatusColor } from '../../appointment/appointmentFunctions';
import DownArrow from '../../buttons/down_arrow.jpeg';
import UpArrow from '../../buttons/up_arrow.jpeg';
import ChatButton from '../../buttons/Chat_button.svg';
import ChatDisabledButton from '../../buttons/chat_disabled.svg';
import { EditIcon } from '../../buttons/EditIcon.tsx';
import { getRoomUnreadMsgCount } from '../../matrix/matrixFuntions.js';

export default function StaffAppointmentTable({ 
    appointments, 
    serviceTypes, 
    isSortAsc, 
    onSortByDate,
    onAcceptAppointment,
    onDeclineAppointment,
    onViewDetails,
    onChat,
    onEditAppointment,
    roomsNotificationCount,
    loggedInUser,
    matrixClient,
    onMarkRead,
    practiceId,
    dispatch,
    token,
    practiceDetails  // ✅ Add practiceDetails prop
}) {

    return (
        <div className='hidden lg:block'>
            <table className='w-full table-fixed border-collapse'>
                <thead className="bg-gray-50 sticky top-0 z-10">
                    <tr className='text-gray-600 text-sm font-medium text-left'>
                        <th className="px-4 py-3 whitespace-normal">Name</th>
                        <th className='px-4 py-3 whitespace-normal'>
                            <button onClick={onSortByDate} className="flex flex-wrap items-center hover:text-blue-600 transition-colors">
                                Requested On
                                {!isSortAsc && <img src={DownArrow} className='ml-1 w-4 h-4' alt="Sort Descending" />}
                                {isSortAsc && <img src={UpArrow} className='ml-1 w-3 h-3' alt="Sort Ascending" />}
                            </button>
                        </th>
                        <th className='px-4 py-3 whitespace-normal'>Symptom</th>
                        <th className='px-4 py-3 whitespace-normal'>Urgency</th>
                        <th className='px-4 py-3 whitespace-normal text-center'>Associate</th>
                        <th className='px-4 py-3 whitespace-normal text-center'>Status</th>
                        <th className='px-4 py-3 whitespace-normal text-center'>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {appointments != null && appointments.map((selectedAppt, index) => {
                        // Skip appointments without proper IDs
                        if (!selectedAppt || !selectedAppt.appointment_basic_details || !selectedAppt.appointment_basic_details._id) {
                            console.log('Skipping appointment with undefined ID:', selectedAppt);
                            return null;
                        }
                        // Get staff associate from audit data
                        const getAssociateUsername = (appointment) => {
                            if (appointment.AppointmentAudits && 
                                appointment.AppointmentAudits.length > 0 && 
                                appointment.AppointmentAudits[appointment.AppointmentAudits.length - 1].associate_id) {
                                
                                const associateId = appointment.AppointmentAudits[appointment.AppointmentAudits.length - 1].associate_id;
                                
                                // Look for the associate in practice users array
                                if (practiceDetails && practiceDetails.practice && practiceDetails.practice.user) {
                                    const staffMember = practiceDetails.practice.user.find(user => user._id === associateId);
                                    if (staffMember) {
                                        const staffName = `${staffMember.firstname} ${staffMember.lastname}`;
                                        // Check if this is the logged-in user
                                        if (loggedInUser && (loggedInUser._id === associateId || loggedInUser.id === associateId)) {
                                            return `${staffName} (You)`;
                                        }
                                        return staffName;
                                    }
                                }
                            }
                            return 'Not Assigned';
                        };
                        
                        const isNewAppointment = selectedAppt.nearest_practices[0].practice_appointment_status === 'NEW';
                        
                        // Return null if appointment data is invalid
                        if (!selectedAppt.nearest_practices || !selectedAppt.nearest_practices[0]) {
                            return null;
                        }
                        
                        return (
                            <tr key={selectedAppt.appointment_basic_details._id} className={`${isNewAppointment ? 'bg-blue-50' : ''} hover:bg-gray-50 transition-colors`}>
                                <td className="px-4 py-3 border-b border-gray-200 [overflow-wrap:anywhere]">
                                    <div className="flex items-center">
                                        <div>
                                            <p className='font-semibold text-gray-800'>{selectedAppt.created_by_user.firstname + ' ' + selectedAppt.created_by_user.lastname}</p>
                                            <p className='text-sm text-gray-600'>{getServiceTypeString(selectedAppt.appointment_basic_details.service_type, serviceTypes)}</p>
                                        </div>
                                        
                                    </div>
                                </td>
                                <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-600 [overflow-wrap:anywhere]">
                                    {formatDateForUI(selectedAppt.appointment_basic_details.create_date_time)}
                                </td>
                                <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-800 [overflow-wrap:anywhere]">
                                    {selectedAppt.appointment_basic_details.reason}
                                </td>
                                <td className="px-4 py-3 border-b border-gray-200 [overflow-wrap:anywhere]">
                                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                        selectedAppt.appointment_basic_details.urgency_type === 'HIGH' ? 'bg-red-100 text-red-700' :
                                        selectedAppt.appointment_basic_details.urgency_type === 'MEDIUM' ? 'bg-yellow-100 text-yellow-700' :
                                        'bg-green-100 text-green-700'
                                    }`}>
                                        {selectedAppt.appointment_basic_details.urgency_type || 'NO_URGENCY'}
                                    </span>
                                </td>
                                <td className="px-4 py-3 border-b border-gray-200 text-center [overflow-wrap:anywhere]">
                                    <span className="text-sm text-gray-600 font-medium">
                                        {getAssociateUsername(selectedAppt)}
                                    </span>
                                </td>
                                <td className="px-4 py-3 border-b border-gray-200 text-center [overflow-wrap:anywhere]">
                                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(selectedAppt.nearest_practices[0].practice_appointment_status)}`}>
                                        {selectedAppt.nearest_practices[0].practice_appointment_status}
                                    </span>
                                </td>
                                <td className="px-4 py-3 border-b border-gray-200 text-center">
                                    <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3">
                                        {/* Chat button - enabled or disabled */}
                                        {selectedAppt.nearest_practices[0].practice_appointment_status === 'SUSPENDED' ? (
                                            <div className="p-2 sm:p-3 min-w-[40px] sm:min-w-[48px] min-h-[40px] sm:min-h-[48px] bg-gray-300 rounded-lg opacity-70 flex items-center justify-center">
                                                <img src={ChatDisabledButton} alt="Chat Disabled" className="w-5 h-5 sm:w-6 sm:h-6 opacity-50" />
                                            </div>
                                        ) : (
                                            <div className="relative">
                                                <button
                                                    onClick={() => {
                                                        // For NEW appointments: first accept, then open chat
                                                        if (selectedAppt.nearest_practices[0].practice_appointment_status === 'NEW') {
                                                            // Debug logs for practice details
                                                            console.log('🔍 === ACCEPTING APPOINTMENT - DEBUG LOGS ===');
                                                            console.log('🔍 Practice Details:', practiceDetails);
                                                            console.log('🔍 Synapse Practice Members Group Name:', practiceDetails.practice?.synapse_practice_members_group_name);
                                                            console.log('Appointment ID:', selectedAppt.appointment_basic_details._id);
                                                            console.log('🔍 Practice ID:', practiceId);
                                                            
                                                            // Call handleAcceptAppointment with practiceDetails
                                                            onAcceptAppointment(selectedAppt, loggedInUser, selectedAppt.created_by_user._id, selectedAppt.nearest_practices[0].service_id, selectedAppt.nearest_practices[0].location_name, practiceId, practiceDetails.practice, dispatch, getServiceTypeString(selectedAppt.appointment_basic_details.service_type, serviceTypes), token);
                                                            // Open chat after accepting
                                                            setTimeout(() => {
                                                                onChat(selectedAppt, loggedInUser, selectedAppt.nearest_practices[0]);
                                                            }, 500);
                                                        } else {
                                                            // For other statuses: just open chat
                                                            onChat(selectedAppt, loggedInUser, selectedAppt.nearest_practices[0]);
                                                        }
                                                    }}
                                                    className="p-1 sm:p-3 min-w-[40px] sm:min-w-[48px] min-h-[40px] sm:min-h-[48px] hover:bg-blue-50 rounded-lg transition-colors flex items-center justify-center"
                                                    title="Chat"
                                                >
                                                    <img src={ChatButton} alt="Chat" className="w-6 h-6 sm:w-6 sm:h-6" />
                                                </button>
                                                {/* Unread message badge */}
                                                {(() => {
                                                    // Skip message count check if appointment data is invalid
                                                    if (!selectedAppt || !selectedAppt.appointment_basic_details || !selectedAppt.appointment_basic_details._id || !selectedAppt.nearest_practices || !selectedAppt.nearest_practices[0]) {
                                                        return null;
                                                    }
                                                    
                                                    // Find the active practice to get the room ID
                                                    const activePractice = selectedAppt.nearest_practices?.find(p => 
                                                        p.practice_appointment_status === 'ACTIVE'
                                                    ) || selectedAppt.nearest_practices?.[0];
                                                    
                                                    // Calculate unread count (only if room ID exists)
                                                    const unreadCount = activePractice?.synapse_room_id 
                                                        ? getRoomUnreadMsgCount(activePractice.synapse_room_id, roomsNotificationCount)
                                                        : 0;
                                                        
                                                    return unreadCount > 0 ? (
                                                        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold">
                                                            {unreadCount > 99 ? '99+' : unreadCount}
                                                        </span>
                                                    ) : null;
                                                })()}
                                            </div>
                                        )}
                                        
                                        {/* View Details button */}
                                        <button
                                            onClick={() => onViewDetails(selectedAppt)}
                                            className="p-1 sm:p-3 min-w-[40px] sm:min-w-[48px] min-h-[40px] sm:min-h-[48px] bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors group flex items-center justify-center"
                                            title="View Details"
                                        >
                                            <EditIcon className='w-7 h-7 sm:w-7 sm:h-7 text-gray-600 transform -rotate-90' />
                                        </button>
                                    </div>
                                </td>
                                
                            </tr>
                        );
                    }).filter(Boolean)}
                </tbody>
            </table>
        </div>
    );
}
